import React, { useState } from "react";
import { ReactComponent as DownloadIcon } from "images/download_for_offline-24px.svg";
import "./ImageMessageContent.scss";
import dayjs from "utils/dayjs";
import LazyLoad from "react-lazy-load";
import useMediaApi from "hooks/useMediaApi";
import { Spinner } from "react-bootstrap";

export default function ImageMessageContent(props) {
  const { message, isTransferred, highlighted } = props;
  const highlightedClass = highlighted ? "highlighted" : "";
  const transferredClass = isTransferred & !highlighted ? "transferred" : "";
  const [isContentVisible, setContentVisible] = useState();
  const { mediaUrl, isLoading } = useMediaApi(
    message.fileUrl,
    message.channel,
    isContentVisible
  );
  const renderMessageTime = (timestamp) => {
    return dayjs(timestamp).format("hh:mm A");
  };

  return (
    <div
      className={`image-msg-ctr ${transferredClass} ${highlightedClass}`}
      data-testid="image-message-content"
    >
      <LazyLoad
        placeholder="loading image"
        offset={100}
        onContentVisible={() => setContentVisible(true)}
        height={180}
        width={300}
      >
        {isLoading ? (
          <Spinner animation="border" />
        ) : (
          <div className="image-container">
            <img
              src={mediaUrl}
              height="100%"
              width="100%"
              className="image-div"
              alt="pic"
            />

            <div className="overlay">
              <div className="download-image">
                <a href={mediaUrl} download>
                  <DownloadIcon />
                  <div className="download-txt">Download</div>
                </a>
              </div>
            </div>
          </div>
        )}
      </LazyLoad>
      <div className="message-time-image">
        {renderMessageTime(message.messageTime)}
      </div>
      <div className="caption-content">{message.message}</div>
    </div>
  );
}
